module.exports = __webpack_public_path__ + "static/media/7_Mining_Infographic.fd67fa40.png";